import { render } from "./CategorySetting.vue?vue&type=template&id=1b8295b5&ts=true"
import script from "./CategorySetting.vue?vue&type=script&lang=ts"
export * from "./CategorySetting.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__